import { useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { getMediaList, getMediaUrl } from '../utils/api';
import './css/carousel.min.css';
import './css/carousel-overrides.css';

interface MediaItem {
  id: number;
  name: string;
  hidden: boolean;
  carouselMedia: boolean;
}

interface ImageCarouselProps {
  accessToken: string | null;
}

const ImageCarousel = ({ accessToken }: ImageCarouselProps) => {
  const [media, setMedia] = useState<MediaItem[]>([]);

  useEffect(() => {
    getMediaList(accessToken)
    .then((data) => {
      if (data && data.length > 0) {
        const filteredMedia = data.filter((m: MediaItem) => !m.hidden && m.carouselMedia);
        setMedia(filteredMedia);
      }
    })
    .catch((error) => {
      console.warn(error);
      alert(error.toString());
    });
  }, [accessToken]);

  if (!media || media.length === 0) {
    return <span></span>;
  }

  return (
    <div style={{maxWidth: '100vw'}}>
      <Carousel showThumbs={false} autoPlay={true} showStatus={false} showArrows={false} infiniteLoop={true} interval={8000}>
        {media.map((m, key) => (
          <div key={key}><img src={getMediaUrl(m.id)} alt={m.name || "carousel image"} /></div>
        ))}
      </Carousel>
    </div>
  );
};

export default ImageCarousel;